import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BotRoutingModule } from './bot-routing.module';
import { AskQuestionComponent } from './ask-question/ask-question.component';
import { AiComponent } from './ai/ai.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { SharedModule } from 'app/shared/shared.module';
import { AskQuestionService } from './ask-question.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgCoreModule } from '@videogular/ngx-videogular/core';

@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    BotRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    ButtonModule,
    CardModule,
    SharedModule,
    DialogModule,
    EditorModule,
    VgControlsModule,
    VgBufferingModule,
    VgOverlayPlayModule,
    VgCoreModule,
    

  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers:[
    AskQuestionService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class BotModule { }
